import { RouteConfig } from 'vue-router';
import ListMaintenance from '@/views/configuration/listMaintenance/ListMaintenance.vue';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { Configuration } from '@/types';
import { RouteConstants } from '@/types/constants/RouteConstants';
import BuiltInListItems from '@/views/configuration/listMaintenance/BuiltInListItems.vue';

const meta = {
  layout: 'TreeView',
  treePath: '/configuration/listMaintenance',
  area: RouteConstants.Areas.ListMaintenance,
  title: 'List Maintenance'
};

export const ListMaintenanceRoutes = [
  {
    ...Configuration.ListMaintenance.ListMaintenance,
    components: {
      default: ListMaintenance,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.ListMaintenance.MaintainBuiltInListItems,
    components: {
      default: BuiltInListItems,
      treeView: ConfigurationTreeView
    },
    meta
  }
] as RouteConfig[];
